import Vue from 'vue'
import { feErrorMonitor } from './stat'

// 全局未捕获异常
window.addEventListener('error', function (event) {
  console.log('====>>> adderror', event)
  const message = event.message + '\n' + event?.error?.stack
  feErrorMonitor({
    msg: message,
    id: event?.error?.name
  })
})
// 全局无catch处理函数的promise
window.addEventListener("unhandledrejection", function (event) {
  console.log('====>>> unhandledrejection', event)
  let reason = event.reason
  const message = reason instanceof Error ? reason.message + '\n' + reason.stack : reason
  feErrorMonitor({
    msg: message,
    id: reason?.response?.statusText || reason?.name || 'Error'
  })
});
// vue组件代码报错
Vue.config.errorHandler = (error, vm, info) => {
  console.log('====>>> Vue.config.errorHandler', error, info)
  const message = vm.$options.name + ':' + error?.message + '\n' + error?.stack
  feErrorMonitor({
    msg: message,
    id: error?.name
  })
}
